import React from 'react';
import HeroSection from '../../components/servicing/sections/HeroSection';
import ServicesSection from '../../components/servicing/sections/ServicesSection';
import QuoteForm from '../../components/servicing/forms/QuoteForm';
import {
  ShieldCheckIcon,
  StarIcon,
  ClockIcon,
  UserGroupIcon,
  CheckBadgeIcon,
  WrenchScrewdriverIcon,
  SparklesIcon,
  TruckIcon
} from '@heroicons/react/24/outline';

const ServicingHome = () => {
  const trustStats = [
    {
      icon: WrenchScrewdriverIcon,
      value: "5000+",
      label: "Bikes Serviced",
      description: "Happy customers nationwide"
    },
    {
      icon: StarIcon,
      value: "4.9",
      label: "Customer Rating",
      description: "Based on 2000+ reviews"
    },
    {
      icon: ClockIcon,
      value: "24hrs",
      label: "Turnaround Time",
      description: "Fast & reliable service"
    },
    {
      icon: UserGroupIcon,
      value: "50+",
      label: "Expert Mechanics",
      description: "Certified professionals"
    }
  ];

  const features = [
    {
      icon: ShieldCheckIcon,
      title: "Quality Guaranteed",
      description: "All services come with warranty protection"
    },
    {
      icon: CheckBadgeIcon,
      title: "Certified Technicians",
      description: "Trained and experienced professionals"
    },
    {
      icon: TruckIcon,
      title: "Doorstep Service",
      description: "Free pickup & delivery available"
    },
    {
      icon: SparklesIcon,
      title: "Genuine Parts",
      description: "100% authentic spare parts used"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-indigo-50">
      {/* Hero Section with Quote Form & Background Image */}
      <section className="relative overflow-hidden">
        {/* Background Image Layer - More visible */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(/imgg2.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Reduced Gradient Overlay - More transparent */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/70 via-indigo-50/60 to-purple-50/70"></div>
        </div>

        {/* Animated Background Elements - Reduced opacity */}
        <div className="absolute inset-0 z-10">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-300 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob"></div>
          <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-2000"></div>
          <div className="absolute -bottom-8 left-20 w-[500px] h-[500px] bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-4000"></div>
        </div>
        
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            {/* Hero Content - First on mobile (order-1), Left on desktop (lg:order-1) */}
            <div className="text-center lg:text-left order-1 lg:order-1">
              <HeroSection />
            </div>

            {/* Quote Form - Second on mobile (order-2), Right on desktop (lg:order-2) */}
            <div className="relative order-2 lg:order-2">
              {/* Floating Card Effect */}
              <div className="absolute -inset-6 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-3xl blur-2xl opacity-20 animate-pulse"></div>
              <div className="relative">
                <QuoteForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section - Quick Value Props */}
      <section className="py-16 bg-white border-y border-gray-200 relative">
        {/* More visible Background Pattern */}
        <div 
          className="absolute inset-0 opacity-15"
          style={{
            // backgroundImage: 'url(/imgg2.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        ></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="group relative bg-white/85 backdrop-blur-sm rounded-2xl p-6 border border-gray-200 hover:border-indigo-300 hover:shadow-xl transition-all duration-300"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 to-purple-50 opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity"></div>
                  <div className="relative">
                    <div className="w-14 h-14 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-lg">
                      <Icon className="h-7 w-7 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 relative">
        {/* Background Image Layer - More visible */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            // backgroundImage: 'url(/imgg2.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Reduced Overlay for readability */}
          <div className="absolute inset-0 bg-gradient-to-b from-gray-50/85 via-white/80 to-gray-50/85"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ServicesSection />
        </div>
      </section>


      

      {/* CTA Section */}
      <section className="py-20 relative">
        {/* Background Image Layer - More visible */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            // backgroundImage: 'url(/imgg2.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Reduced Overlay */}
          <div className="absolute inset-0 bg-white/85"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-br from-indigo-50/90 to-purple-50/90 backdrop-blur-sm rounded-3xl p-12 border-2 border-indigo-200 shadow-2xl">
            <SparklesIcon className="h-16 w-16 text-indigo-600 mx-auto mb-6" />
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Ready to Experience Premium Service?
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Book your vehicle service today and get exclusive offers on first-time bookings
            </p>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-lg font-semibold rounded-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <span>Book Service Now</span>
              <svg className="ml-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Custom Animations */}
      <style jsx>{`
        @keyframes blob {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          25% {
            transform: translate(20px, -50px) scale(1.1);
          }
          50% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          75% {
            transform: translate(50px, 50px) scale(1.05);
          }
        }

        .animate-blob {
          animation: blob 20s infinite ease-in-out;
        }

        .animation-delay-2000 {
          animation-delay: 2s;
        }

        .animation-delay-4000 {
          animation-delay: 4s;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-blob {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
};

export default ServicingHome;
